// create a stimulus controller than handles onclick events for the datalist options and sets the range input to the value of the option
import { Controller } from "@hotwired/stimulus";
// import { useDebounce } from "stimulus-use"

export default class extends Controller {
  static targets = ["range", "parent"];

  connect() {
    // useDebounce(this, { wait: 100 })
    this.setRangeValue(this.rangeTarget.value);
  }

  setRangeValue(value) {
    // Calculate percentage of value w/ regards to min and max
    const min = this.rangeTarget.min;
    const max = this.rangeTarget.max;
    const percentage = ((value - min) / (max - min)) * 100;

    // Update progress fill
    this.rangeTarget.style.background = `linear-gradient(to right,rgb(255 255 255 / 50%) ${percentage}%,rgb(255 255 255 / 0%) ${percentage}%)`;
    // Update animation
    this.rangeTarget.style.setProperty(
      "--thumb-rotate",
      `${percentage * 3.6}deg`
    );

    // Update input value & dataset label
    this.rangeTarget.value = value;
    this.parentTarget.dataset.value = value;
  }

  handleOptionClick(event) {
    const value = event.target.value;
    this.setRangeValue(value);
  }
}
